<ng-container *ngIf="canDisplay">
    <div class="flex flex-col md:flex-row md:space-x-2 items-center"
         [class.justify-center]="centered">
        <div
            [title]="(rating | number: '0.1-1') + ' / 5'"
            class="inline-flex items-baseline"
            [class.interactive]="interactive"
            [class.unrated]="rating == null"
        >
            <div *ngFor="let star of stars; index as i; trackBy: trackByFn">
                <fa-icon
                    (click)="starClicked(i)"
                    (mouseenter)="hoverStar(i)"
                    class="flex items-center"
                    [ngClass]="{
                    'text-gray-400': (rating == null && hoverValue === -1) || hoverValue < i,
                    'text-yellow-400': rating != null && hoverValue === -1,
                    'text-yellow-300': hoverValue >= i
                }"
                    [icon]="star"
                    [size]="size"
                    [class.hovered]="hoverValue >= i"
                ></fa-icon>
            </div>
        </div>
        <div class="text-sm text-gray-500" *ngIf="reviewCount != null">
            <span *ngIf="!reviewCountRouterLink && !reviewCountAnchor">{{ reviewCount }} reviews</span>
            <a *ngIf="reviewCountRouterLink" [routerLink]="reviewCountRouterLink"> {{ reviewCount }} reviews </a>
            <button *ngIf="reviewCountAnchor" (click)="scrollToReviewsAnchor(reviewCountAnchor)">
                {{ reviewCount }} reviews
            </button>
        </div>
    </div>

</ng-container>
